export default "__VITE_ASSET__DYxIMUKF__"